<template>
  <MerchantMessages
    v-if="authorize !== 'registration'"
    ref="MerchantMessages"
  ></MerchantMessages>
</template>

<script>
import MerchantMessages from '@/modules/merchantMessages/components/MerchantMessages.vue';
import Toolbar from '@/view/layout/header/Toolbar.vue';
import roleMiddlewaresMixin from '@/core/mixins/roleMiddlewaresMixin';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      EventBus: null,
    };
  },
  mixins: [roleMiddlewaresMixin],
  components: {
    Toolbar,
    MerchantMessages,
  },
  computed: {
    ...mapGetters(['authorize'])
  },
  methods: {
    saveHandler() {
      // save has Defined In Child Component
      this.$refs['MerchantMessages'].save();
    },
    newHandler() {
      this.$refs['MerchantMessages'].new();
    },
    listHandler() {
      this.$refs['MerchantMessages'].showList();
    },
    returnToList() {
      this.$refs['MerchantMessages'].returnToList();
    },
  },
};
</script>

<style></style>
